function createCdnFilter(store) {
    function cdn(link, { width, height } = {}) {
        if (link.includes('http://') || link.includes('https://') || link.substring(0, 1) === '/') return link;

        let cdn_url = process.env.VUE_APP_CDN || 'https://cdn.lotify.com';
        let resize_path = process.env.VUE_APP_CDN_RESIZE_PATH || '';
        let v = `?v=${store.getters.cacheTimestamp || '1623414715946'}`;

        resize_path = width || height ? resize_path : '';
        width = width ? `&width=${width}` : '';
        height = height ? `&height=${height}` : '';
        return `${cdn_url}${resize_path}/${link}${v}${width}${height}`;
    }

    return cdn;
}

export { createCdnFilter };
